"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _MigrationBox = require("./MigrationBox.scss");

var _MigrationBox2 = _interopRequireDefault(_MigrationBox);

var _Preloader = require("@quixeltools/quixel-ui-library/dist/components/common/website/Preloader");

var _Preloader2 = _interopRequireDefault(_Preloader);

var _EpicSubscription = require("./EpicSubscription");

var _EpicSubscription2 = _interopRequireDefault(_EpicSubscription);

var _SwitchPlans = require("./SwitchPlans");

var _SwitchPlans2 = _interopRequireDefault(_SwitchPlans);

var _components = require("components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MigrationBox = function (_React$Component) {
  (0, _inherits3.default)(MigrationBox, _React$Component);

  function MigrationBox() {
    (0, _classCallCheck3.default)(this, MigrationBox);
    return (0, _possibleConstructorReturn3.default)(this, (MigrationBox.__proto__ || (0, _getPrototypeOf2.default)(MigrationBox)).apply(this, arguments));
  }

  (0, _createClass3.default)(MigrationBox, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          isLoading = _props.isLoading,
          subscriptionError = _props.subscriptionError,
          showEpicSubscription = _props.showEpicSubscription,
          showSwitchingPlans = _props.showSwitchingPlans,
          hasActiveLegacySubscription = _props.hasActiveLegacySubscription,
          isEpicLogin = _props.isEpicLogin,
          hasUnrealLicense = _props.hasUnrealLicense,
          subscribeToUnrealUnlimited = _props.subscribeToUnrealUnlimited,
          subscribing = _props.subscribing,
          shouldUpdateEula = _props.shouldUpdateEula,
          welcome = _props.welcome;


      var title = showEpicSubscription ? welcome ? "Welcome" : "Go Unlimited" : "Go Unlimited";

      return _react2.default.createElement(
        "section",
        { className: _MigrationBox2.default.popupBox },
        isLoading ? _react2.default.createElement(
          "div",
          { className: _MigrationBox2.default.preloaderWrap },
          _react2.default.createElement(_Preloader2.default, null)
        ) : _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            _components.Popup,
            null,
            _react2.default.createElement(
              _components.Popup.Header,
              null,
              title
            ),
            showEpicSubscription ? _react2.default.createElement(
              "div",
              { className: _MigrationBox2.default.epicSubscription },
              _react2.default.createElement(_EpicSubscription2.default, {
                subscriptionError: subscriptionError,
                isEpicLogin: isEpicLogin,
                hasUnrealLicense: hasUnrealLicense,
                subscribeToUnrealUnlimited: subscribeToUnrealUnlimited,
                subscribing: subscribing,
                shouldUpdateEula: shouldUpdateEula,
                welcome: welcome
              })
            ) : _react2.default.createElement(
              "div",
              null,
              showSwitchingPlans && _react2.default.createElement(_SwitchPlans2.default, {
                subscribeToUnrealUnlimited: subscribeToUnrealUnlimited
              })
            )
          )
        )
      );
    }
  }]);
  return MigrationBox;
}(_react2.default.Component);

exports.default = MigrationBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/MigrationBox.jsx
// module id = 2964
// module chunks = 0